module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-prez-right-8fc65acc2b6471cbf546c9d862eb2a65.svg";